import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Pagination, Popover, Space, Table, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import ConfirmationModal from "../modal/ConfirmationModal";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function PlanApprovalsTable(props) {
  const [rejectModal, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [approvalId, setApprovalId] = useState("");
  const [approvalAction, setApprovalAction] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.tableLoading);
  }, [props.tableLoading]);

  function getStatusColor(status) {
    let color = "";
    if (status === "Pending") {
      color = "orange";
    } else if (status === "Approved") {
      color = "green";
    } else {
      color = "red";
    }
    return color;
  }

  function getChange(title, from, to) {
    return (
      <div className="text-xs mb-2">
        <div>{title}</div>
        <div className="text-gray-500">
          {from || "-"} &gt; {to || "-"}
        </div>
      </div>
    );
  }

  function getChangedData(data) {
    let output = [];
    let changes = 0;

    if (data?.title) {
      changes++;
      output.push(getChange("Title", data?.title?.from, data?.title?.to));
    }
    if (data?.target) {
      changes++;
      output.push(getChange("Target", data?.target?.from, data?.target?.to));
    }
    if (data?.assignTo) {
      changes++;
      output.push(
        getChange("Target", data?.assignTo?.from, data?.assignTo?.to)
      );
    }
    if (data?.targetDate) {
      changes++;
      output.push(
        getChange("Target Date", data?.targetDate?.from, data?.targetDate?.to)
      );
    }
    if (data?.description) {
      changes++;
      output.push(
        getChange("Description", data?.description?.from, data?.description?.to)
      );
    }
    if (data?.attributes) {
      data?.attributes?.forEach((attribute) => {
        changes++;
        output.push(
          getChange(attribute?.attribute, attribute?.from, attribute?.to)
        );
      });
    }

    return (
      <div>
        {changes}
        <Popover
          className="ml-1 cursor-pointer"
          content={output}
          title="Changes"
        >
          <span className="text-blue-500">
            <InfoCircleOutlined />
          </span>
        </Popover>
      </div>
    );
  }

  const columns = [
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      render: (text, record) => (
        <Tooltip placement="topLeft" title={record?.plan?.title}>
          {record?.plan?.title}
        </Tooltip>
      ),
      ellipsis: true,
      fixed: "left",
      width: 300,
    },
    {
      title: "Plan Level",
      dataIndex: "planLevel",
      key: "planLevel",
      render: (text, record) => (
        <div>{record?.plan?.planLevel?.title || "-"}</div>
      ),
    },
    {
      title: "Parent Plan",
      dataIndex: "parentPlan",
      key: "parentPlan",
      render: (text, record) => (
        <div>
          {record.plan?.cascadeFrom?.id ? (
            <Tooltip
              placement="topLeft"
              title={record.plan?.cascadeFrom?.title}
            >
              {record.plan?.cascadeFrom?.title}
            </Tooltip>
          ) : record.plan?.splitFrom?.id ? (
            <Tooltip placement="topLeft" title={record.plan?.splitFrom?.title}>
              {record.plan?.splitFrom?.title}
            </Tooltip>
          ) : (
            "-"
          )}
        </div>
      ),
      ellipsis: true,
      width: 300,
    },
    {
      title: "No of Changes",
      dataIndex: "archivedTarget",
      key: "archivedTarget",
      render: (text, record) => <div>{getChangedData(record?.planData)}</div>,
    },
    {
      title: "Added by",
      dataIndex: "addedBy",
      key: "addedBy",
      ellipsis: true,
      render: (text, record) => (
        <div>
          {record.requester?.designationName +
            ", " +
            record.requester?.unitName}
        </div>
      ),
    },
    {
      title: "Added on",
      dataIndex: "addedOn",
      key: "addedOn",
      render: (text, record) => <div>{record.updatedOn?.slice(0, 10)}</div>,
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (text) => (
        <Tag color={getStatusColor(text)}>{text?.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          {record.status === "Pending" && (
            <>
              <Tooltip title={"Approve"}>
                <div
                  onClick={() => {
                    setApproveModal(true);
                    setApprovalId(record.id);
                    setApprovalAction("Approved");
                  }}
                  className="text-green-500 hover:text-green-600 cursor-pointer"
                >
                  <CheckCircleOutlined />
                </div>
              </Tooltip>
              <Tooltip title={"Reject"}>
                <div
                  onClick={() => {
                    setRejectModal(true);
                    setApprovalId(record.id);
                    setApprovalAction("Rejected");
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <CloseCircleOutlined />
                </div>
              </Tooltip>
            </>
          )}
        </Space>
      ),
      fixed: "right",
      width: 90,
    },
  ];
  return (
    <>
      <>
        <Table
          pagination={false}
          loading={loading}
          columns={columns}
          dataSource={props.data}
          scroll={{ x: 1300 }}
        />
        <div className="text-center mt-6">
          <Pagination
            onChange={(num) => {
              props.changePage(num);
              props.setPage(num);
            }}
            current={props.current}
            total={props.data?.totalCount || 0}
            pageSize={LIMIT_PER_PAGE}
          />
        </div>
      </>

      <ConfirmationModal
        visible={rejectModal}
        handleCancel={() => {
          setRejectModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to reject this?"
        title="Reject approval"
        handleOk={() => props.rejectApproval(approvalId, approvalAction, "all")}
      />
      <ConfirmationModal
        visible={approveModal}
        handleCancel={() => {
          setApproveModal(false);
          setApprovalId("");
          setApprovalAction("");
        }}
        text="Are you sure want to approve this?"
        title="Approve approval"
        handleOk={() =>
          props.approveApproval(approvalId, approvalAction, "all")
        }
      />
    </>
  );
}

export default PlanApprovalsTable;
